import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultWorkflowRepresentationResource,
    useWorkflowRepresentationActions,
    WorkflowRepresentationMutationResourceSchema,
    WorkflowRepresentationResource,
} from '../../../../../resource/resources/artifacts/use_case/representation/workflowRepresentationResource';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import React from 'react';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    Form_DisplayComponentBaseView,
} from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { WorkflowRepresentationContent } from './WorkflowRepresentationContent';

export const WorkflowRepresentationCreationDialog= ({ onClose, parentId, autoGeneratedProps, onCreated }: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: WorkflowRepresentationResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const workflowRepresentationActions = useWorkflowRepresentationActions()
    const addWorkflowRepresentation = workflowRepresentationActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: WorkflowRepresentationMutationResourceSchema,
        defaultValues: {
            ...defaultWorkflowRepresentationResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addWorkflowRepresentation.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Workflow Representation'}
            resourceType={ResourceType.WORKFLOW_REPRESENTATION}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <WorkflowRepresentationContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};